// nuolino-admin/src/features/anamnesis/anamnesis-api.ts

import { http } from '@/lib/http';

export interface Anamnesis {
  id: string;
  patientId: string;
  version: number;
  name: string;
  age: number;
  birthDate: string;
  sex: string;
  weight: string;
  height: string;
  objectives: string[];
  diseases: string[];
  allergies: string[];
  restrictions: string[];
  activity: string;
  medications: string[];
  pathologies: string[];
  likes: string[];
  dislikes: string[];
  measurements: Record<string, unknown> | null;
  date: string;
  analysis: string;
  createdAt: string;
  updatedAt: string;
}

export async function getCurrentAnamnesis(patientId: string, signal?: AbortSignal): Promise<Anamnesis | null> {
  return http.get<Anamnesis | null>(
    `/api/v1/anamnesis/current?patientId=${encodeURIComponent(patientId)}`,
    { signal },
  );
}

export interface SaveAnamnesisInput {
  name: string;
  age: number;
  birthDate: string;
  sex: string;
  weight: string;
  height: string;
  objectives: string[];
  allergies: string; // string separada por vírgula (espelha o app)
  foodRestrictions: string[];
  activityLevel: string;
  medications: string[];
  medicalHistory: string[];
  foodPreferences: string[];
  foodAversions: string[];
  measurements?: Record<string, unknown> | null;
}

export async function saveAnamnesis(patientId: string, input: SaveAnamnesisInput): Promise<Anamnesis> {
  return http.post<Anamnesis>(
    `/api/v1/anamnesis?patientId=${encodeURIComponent(patientId)}`,
    input,
  );
}